<template>
  <div class="index_content">
    <div class="container">
      <!-- 内容一 -->
      <div class="swiper">
        <swiper :options="swiperOption" ref="mySwiper" class="pic_scroller"
                @slideChangeTransitionEnd='slideChangeTransitionEnd'>
          <swiper-slide v-for='(i,k) in getIndexData.banner' :key='k'>
            <div class="pic">
              <!-- <div class="pic-des">
                  <div>汇聚独特的创意</div>
                  <div>Unique originality</div>
              </div> -->
              <div class="pic-wrap" @click="bannerGo(i)">
                <img :src="i.img" alt="">
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="word">
          <div class="dots">
            <div class="dot" v-for='(i,k) in imgsLs' :key='k' :class="{active: curDotIdx===k}"
                 @mouseover="dotMouseover(k)"></div>
          </div>
          <span class="title">{{getIndexData.fixedFieldMap['home.ourAddvanttage']}}</span>
<!--          <span class="etitle" v-if="langType=='zh'">Our addvantage</span>-->
          <div class="word-cont" v-html="introduces1">
            {{introduces1}}
            <!--            <p>-->
            <!--              广东衡德律师事务所，是于2001年成立的以商业法律事务为主的律师事务所，注册地在中国广州市，业务范围覆盖广州、深圳、香港、澳门等中国粤港澳大湾区，下设多个分所或办事处。律所主要以银行金融、不良资产处置、股权融资、知识产权、商业贸易、并购和投资等诉讼及非诉讼业务。核心客户包括中国工商银行广东省分行、中国建设银行广东省分行、中国银行广东省分行、中国农业银行广东省分行、交通银行股份有限公司总行及广东省分行等十多家银行金融机构及中国电信集团广东省公司、中国联通集团广东省公司、中国人民保险财产广东省公司等大型国有企业。 律所由毕业于国内知名法学院校的律师组成专业团队，具有精湛专业能力和丰富实践经验，是中国广东省首批“涉外律师事务所”之一，能以英语、日语和韩语等处理跨境法律事务，并与多国（地区）律所有广泛且深入的法律事务合作关系，联手处理跨境复杂法律问题。-->
            <!--            </p>-->
          </div>
        </div>
      </div>

      <!-- 内容二 -->
      <div class="msg">
        <div class="tabs">
          <div class="tab" @click="goService(i, k)" @mousemove='service(k)' v-for='(i,k) in serviceLs' :key='k'
               :class="{active: curServiceIdx===k}">{{i.name}}
          </div>
        </div>
        <div class="pic" :style='service_bg' @click="goService(0, 0)"></div>
      </div>

      <!-- 内容三 -->
      <div class="cases" :style='base_bg'>
        <div class="case" v-for='(i,k) in activityLs' :key='k' @mousemove='activityNavIdx(k)' @click="goActivity(k)">
          <div class="pc" :style='case_item_bg[k]'></div>
          <div class="pb" :class="{active: curActivityIdx===k}">{{i.name}}</div>
        </div>
      </div>

      <!-- 内容四 form -->
      <div class="form">
        <div class="fcontainer">
          <div class="left">
            <div class="des" v-html="introduces2">
              {{introduces2}}
              <!--              您好！这里是广东衡德律师事务所，本所有专业律师团队提供优质法律服务，如果您在本所的法律服务领域需要律师提供帮助的，欢迎在此留言，我们将尽快安排人士与您联系。-->
              <br>
            </div>
            <div class="contact">
              <div class="item">
                <div :class="langType=='zh'?'title1':'title'">
                  <div class="icon">
                    <i class="iconfont icon-dianhua"></i>
                  </div>
                  <span >{{getIndexData.fixedFieldMap['home.contactNumber']}}:</span>
                </div>
                <div class="content">
                  <div v-for="(value,key,index) in contactInformationPhone">
                   <span>{{value}}</span>
                  </div>
<!--                  <div><span>020-22116289 (广州)</span></div>-->
<!--                  <div><span>0750-3283384 (江门) </span></div>-->
                  <!--                  <div><span>0760-22130810 (中山) </span></div>-->
                </div>
              </div>
              <div class="item">
                <div :class="langType=='zh'?'title1':'title'">
                  <div class="icon">
                    <i class="iconfont icon-zuobiao"></i>
                  </div>
                  <span>{{getIndexData.fixedFieldMap['joinUs.address']}}:</span>
                </div>
                <div class="content">
                  <div v-for="(value,key,index) in contactInformationAddress">
                    <span>{{value}}</span>
                  </div>
<!--                  <div><span>广东省广州市天河区珠江新城海安路13号越秀财富世纪广场A1栋907室(广州总所)</span></div>-->
<!--                  <div><span>广东省江门市蓬江区建设二路98号万源大厦A栋10楼A08单位（江门分所）</span></div>-->
                  <!--                  <div><span>中山市中山三路利国际公馆3座7楼701室 (中山)</span></div>-->
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <i class="iconfont icon-youxiang"></i>
                </div>
                <span>{{contactInformationEmail}}</span>
<!--                <span>公司邮箱: hengdezixun@hornlaw-firm.com</span>-->
              </div>
            </div>
          </div>
          <!-- 输入框容器 -->
          <div class="right" v-show="false">
            <div class="input-w">
              <div class="input-item">
                <div class="span">{{getIndexData.fixedFieldMap['home.name']}}</div>
                <input type="text" v-model='name'>
              </div>
              <div class="input-item">
                <div class="span">{{getIndexData.fixedFieldMap['home.phone']}}</div>
                <input type="text" v-model='phone'>
              </div>
              <div class="input-item">
                <div class="span">{{getIndexData.fixedFieldMap['home.email']}}</div>
                <input type="text" v-model='email'>
              </div>
              <div class="input-item">
                <div class="span">{{getIndexData.fixedFieldMap['home.context']}}</div>
                <textarea name="" id="" cols="30" rows="10" v-model='context'></textarea>
              </div>
              <div class="submit" @click="submit">{{getIndexData.fixedFieldMap['home.submit']}}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import {mapGetters} from 'vuex'

  let img = require('img/banner1.jpg')

  export default {
    data: () => ({
      swiperOption: {
        direction: 'vertical',
        autoplay: {
          delay: 3500
        },
        // loop: true,
        speed: 400,
      },
      imgsLs: [img, img, img], // 内容一
      curDotIdx: 0, // banner 导航

      curServiceIdx: 1, //  内容二 服务导航索引

      curActivityIdx: 0, //  内容二 服务导航索引

      introduces1: "",
      introduces2: "",
      contactInformationPhone: [],
      contactInformationAddress: [],

      contactInformationEmail:'',

      name: '',
      phone: '',
      email: '',
      context: '',
      langType:'zh',
    }),
    computed: {
      ...mapGetters(['getIndexData']),
      base_bg() {
        return {
          background: `url(${require('img/case_bg.jpg')}) no-repeat`,
          backgroundSize: '100% 100%'
        }
      },
      case_item_bg() {
        return [
          {background: `url(${require('img/case_item_bg.jpg')}) no-repeat`, backgroundSize: '100% 100%'},
          {background: `url(${require('img/case_item_bg2.jpg')}) no-repeat`, backgroundSize: '100% 100%'},
          {background: `url(${require('img/case_item_bg3.jpg')}) no-repeat`, backgroundSize: '100% 100%'}
        ]
      },
      service_bg() {
        return {
          background: `url(${require('img/service1.jpg')}) no-repeat`,
          backgroundSize: '100% 100%'
        }
      },
      // 业务
      serviceLs() {
        return this.getIndexData.casesEnum.slice(0, 5)
      },
      // 评述
      activityLs() {
        return this.getIndexData.activityEnum.slice(0, 3)
      }
    },
    created() {
      console.log(
        this.getIndexData
      )
      this.langType = localStorage.getItem('langType')
      let label=[]
      if(this.langType=='zh'){
        label=['content','phone','address','email']
      }else{
        label=['contentEn','phoneEn','addressEn','emailEn']
      }
      this.introduces1 = this.getIndexData.introduces[0][label[0]];
      this.introduces2 = this.getIndexData.introduces[1][label[0]];
      this.contactInformationPhone = this.getIndexData.contactInformation[0][label[1]].split(",");
      this.contactInformationAddress = this.getIndexData.contactInformation[0][label[2]].split(",");
      this.contactInformationEmail = this.getIndexData.contactInformation[0][label[3]];


    },
    methods: {
      bannerGo(data) {
        window.open(data.url)
      },
      dotMouseover(idx) {
        this.$refs.mySwiper.swiper.slideTo(idx)
      },
      slideChangeTransitionEnd() {
        this.curDotIdx = this.$refs.mySwiper.swiper.activeIndex
      },

      // 业务导航idx
      service(k) {
        this.curServiceIdx = k
      },
      // 跳转业务
      goService(i, k) {
        this.$router.push('/cases/' + k)
        document.documentElement.scrollTop = 0
      },

      // 评述导航idx
      activityNavIdx(k) {
        this.curActivityIdx = k
      },
      // 跳转导航
      goActivity(k) {
        this.$router.push('/activity/' + k)
        document.documentElement.scrollTop = 0
      },

      submit() {
        if (this.isSubmited) {
          this.name = this.phone = this.email = this.context = ''
          alert('请勿重复提交')
          return
        }
        if (!this.name || !this.phone || !this.email || !this.context) {
          alert('请填写完整内容')
          return
        }
        if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.email)) {
          alert('请填写正确邮箱')
          return
        }
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          alert('请填写正确手机号码')
          return
        }

        this.$$$api.sendEmail({
          name: this.name,
          phone: this.phone,
          email: this.email,
          context: this.context,
        }).then(res => {
          if (res.data.code === 0) {
            this.isSubmited = true
          }
          this.name = this.phone = this.email = this.context = ''
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  .index_content
    mt(-300)

  .container
    fs(0)
    container()

    .form
      bg(#fff)

      .fcontainer
        ppr()
        container()
        hh()
        bg(#fff)
        pb(25)

        & > div
          vertical-align top
          d(inline-block)

        .left
          width 50%
          box-sizing border-box
          pt(30)

          .title
            mb(25)

            .mtitle
              fs(24)
              c(rgb(122, 120, 118))

            .ctitle
              c(rgb(122, 120, 118))
              fs(18)
              pl(20)

          .des
            c(rgb(122, 120, 118))
            fs(17)
            mt(20)
            mb(20)
            text-indent 30px

            p
              text-indent -5px
              mt(20)

          .contact
            c(rgb(122, 120, 118))

            .item
              pt(16)

              .title1
                width 100px
                d(inline-block)
                vertical-align top
              .title
                width 160px
                d(inline-block)
                vertical-align top
              .content
                vertical-align top
                line-height 22px
                d(inline-block)
                width: 350px

                span
                  padding-left 0

              .icon
                width 25px
                height 25px
                line-height 25px
                border-radius 50%
                d(inline-block)
                vertical-align middle
                bg(rgb(247, 170, 5))
                text-align center

                i
                  c(#fff)
                  fs(12)

              span
                vertical-align middle
                fs(12)
                pl(20)

        .right
          width 50%
          ppa()
          bottom 25px

          .input-w
            w(592)
            margin-left auto

            .submit
              &:hover
                cursor pointer
              ww()
              h(40)
              lh(40)
              bg(rgb(247, 170, 5))
              mt(20)
              fs(18)
              c(#fff)
              text-align center

            .input-item
              ppr()
              pt(20)

              .span
                ppa()
                ml(-95)
                fs(14)
                c(rgb(247, 170, 5))
                mt(3)

              input
                ww()
                h(20)
                fs(14)
                c(#7a7876)
                text-indent 5px

              textarea
                text-indent 5px
                c(#7a7876)
                fs(14)
                ww()
                resize none
                h(100)


    .swiper
      bg(rgb(243, 243, 243))
      h(520)

      & > div
        d(inline-block)
        vertical-align top
        width 50%
        hh()
        ppr()

      .pic_scroller
        oh()

        .pic
          wh()
          ppr()

          .pic-wrap
            ppa()
            hh()
            ww()
            oh()

            img
              ww()
              hh()

          .pic-des
            h(156)
            box-sizing border-box
            pt(95)
            bg(#fff)
            d(inline-block)

            div
              fs(18)
              c(rgb(247, 170, 5))
              pl(20)
              pr(20)

              &:nth-of-type(1)
                pb(5)

      .word
        box-sizing border-box
        pt(25)
        pl(36)
        pr(36)
        ppr()
        bg(#f3f3f3)

        .dots
          ppa()
          bottom 0
          left 50px

          .dot
            width 17px
            height 17px
            border-radius 50%
            mb(20)
            bg(rgb(82, 69, 93))
            display none

            &.active
              bg(rgb(247, 170, 5))

            &:hover
              cursor pointer

        .title
          fs(24)
          c(rgb(75, 73, 73))

        .etitle
          c(rgb(94, 94, 94))
          fs(18)
          pl(20)

        .word-cont
          pt(0)
          c(rgb(122, 120, 118))
          fs(0)

          p
            lh(30)
            text-indent 31px
            fs(17)

    .msg
      bg(gray)
      mt(50)
      d(flex)
      display none

      .tabs
        width 62%
        cursor pointer

        .tab
          h(100)
          lh(100)
          fs(18)
          bg(rgb(247, 170, 5))
          box-sizing border-box
          pl(50)

          &.active
            bg(#fff)
            box-shadow 0 2px 3px rgba(0, 0, 0, .4)
            ppr()
            c(rgb(247, 170, 5))

      .pic
        width 38%
        bg(red)

    .cases
      &:hover
        cursor pointer
      _flex()
      pl(98)
      mt(50)
      pr(98)
      bg(pink)
      display none

      .case
        w(353)
        h(409)
        ppr()

        .pc
          h(290)

        .pb
          h(65)
          lh(65)
          ppa()
          bottom 0
          left 0
          ww()
          fs(20)
          text-align center
          box-sizing border-box
          border 1px solid rgb(247, 170, 5)
          bg(#fff)
          c(rgb(247, 170, 5))

          &.active
            bg(rgb(247, 170, 5))
            c(#fff)


</style>



// WEBPACK FOOTER //
// src/components/index/index_content.vue